module.exports = __webpack_public_path__ + "img/person-dress-simple.fabf5332.svg";